import { AgxApi } from '../../helpers/http';
import { DevContractStage } from '../Campaigns/Types/types';

export interface DevProgressContractWorkflowRequest {
  campaignId: string;
  contractId: string;
  status: DevContractStage;
}

export const activitiesApi = (authToken: string) =>
  new AgxApi('activities', authToken);

export const progressDevContractWorkflow = async (
  authToken: string,
  request: DevProgressContractWorkflowRequest
) => {
  await activitiesApi(authToken).post('DevProgressContractWorkflow', request);
};
